export default __webpack_public_path__ + "static/media/hello-light.7aa4f78d.svg";